<template>
  <div>
    <v-layout>
      <v-flex
        :xs12="withSlider"
        :xs8="!withSlider"
      >
        <div
          :class="'viewer-image ' + (compact ? 'viewer-compact-container' : '')"
          @mouseleave="hideNav" @mouseenter="showNav"
          ref="viewer-image"
          v-touch="{
            left: () => nextImg(),
            right: () => prevImg()
          }"
          :style="viewerContainerStyle"
        >

          <!--- navigation icons -->

          <div
            v-if="!compact"
            class="viewer-nav"
          >
            <a class="prev-btn" :class="(
              !showingImageNavigation ? ' img-transparent' : ''
              )" @click="prevImg()"
            >
              <i class="fa fa-chevron-left" />
            </a>
            <a class="next-btn" :class="(
              !showingImageNavigation ? ' img-transparent' : ''
              )" @click="nextImg()"
            >
              <i class="fa fa-chevron-right" />
            </a>
            <span :class="'pika-counter ' + (
              !showingImageNavigation ? ' img-transparent' : ''
              )" >{{ selectedImageIndex + 1 }}/{{ images.length }}
            </span>

            <span
              v-if="!homepage"
              :class="'expand-icon ' + (
              !showingImageNavigation ? ' img-transparent' : ''
              )"
              @click="showFull"
            >
              <v-icon style="color: white;">fas fa-expand-arrows-alt</v-icon>
            </span>
          </div>
          <!--- // navigation icons -->

          <!--- preview image area  -->


          <div
            :class="'viewer-image-middle-container '"
          >

            <!-- preload images -->
            <img
              v-if="preloadImg1 && images[preloadImg1]"
              :src="fullPath + images[preloadImg1].image"
              style="width: 30px;position: absolute; left: 10000px"
            />
            <img
              v-if="preloadImg2 && images[preloadImg2]"
              :src="fullPath + images[preloadImg2].image"
              style="width: 30px;position: absolute; left: 10000px"
            />
            <!-- /preload images -->

            <img
              :src="fullPath + imageUrl1"
              :class="(
                image1Transparent ? ' img-transparent' : ''
              )"
              @click="showFull"
              :style="previewImageStyle"
            />
            <img
              :src="fullPath + imageUrl2"
              :class="(
                image2Transparent ? ' img-transparent' : ''
              )"
              @click="showFull"
              :style="previewImageStyle"
            />
          </div>
          <!--- // preview image area  -->

        </div>

        <!--- homepage title -->

        <div
          v-if="homepage"
          class="hot-img-caption"
          style="display: block; opacity: 1;"
          v-html="imageTitleComputed"
          @click="showFull"
        ></div>

        <!--- slider thumbnails -->
        <div
          v-if="!compact && withSlider"
          class="viewer-thumbnails-outer"
          v-touch="{
            left: () => nextImgPage(),
            right: () => prevImgPage()
          }"
          :style="homepage ? 'width:calc(100% - 276px);left:270px;' : ''"
        >
          <div class="viewer-thumbnails" ref="viewer-thumbnails">
            <template v-if="!compact && compact">
              <div
                v-for="(image, imageIndex) in images"
                :key="imageIndex"
                class="viewer-thumbnail"
                :style="'left:' + imagePreviewThumbnailLeftOffset + 'px'"
              >
                <div
                  class="viewer-thumbnail-inner"
                  @click="changeImage(image, imageIndex)"
                  :ref="'thumbnail-ref-' + imageIndex">
                  <img
                    v-if="image && image.image"
                    :src="s3url + imgFolder + '/' + image.image"
                    :class="'viewer-thumbnail-image' + (
                      imageIndex !== selectedImageIndex ? ' not-selected' : ''
                      )"
                  />
                </div>
              </div>
            </template>
          </div>
        </div>
        <!--- // slider thumbnails -->
      </v-flex>

      <!-- preview sideimages -->
      <v-flex
        v-if="!withSlider"
        xs4
      >
        <v-layout wrap>
          <v-flex xs12 :style="sideImageContainerStyle">
            <img
              :src="fullPath + previewSideImage2.image"
              style="height:100%;"
              @click="nextImg(); showFull();"
            />
          </v-flex>
          <v-flex xs12 :style="sideImageContainerStyle">
            <img
              :src="fullPath + previewSideImage3.image"
              style="height:100%;"
                @click="nextImg(); nextImg(); showFull();"
            />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import sharedMethods from './../methods/sharedMethods'
import methods from './../methods'
import { createHelpers } from 'vuex-map-fields'
import state from './../state.js'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})


export default {
  name: 'ObjectImagesPreview',

  data: () => {
    return {

    }
  },

  props: {
    images: {
      type: Array,
      default: () => {
        return []
      }
    },
    compact: {
      type: Boolean,
      default: false
    },
    imgFolder: {
      type: String,
      default: null
    }
  },

  computed: {
    ...mapFields(Object.keys(state)),

    imageTitleComputed () {
      return this.imageTitle.replace(', Costa del Sol, Spain', '')
    },

    sideImageContainerStyle () {
      return {
        height: (((this.contentAreaWidth / 12 * 4) / 4 * 3) - 1) + 'px',
        // background: 'gray',
        borderTop: '2px solid white',
        borderRight: '2px solid white',
        overflow: 'hidden',
        marginTop: '0px'
      }
    },

    withSlider () {
      return !!this.homepage
    },

    fullPath () {
      return this.s3url + this.imgFolder + '/' + (
        this.compact ? 'medium/' : ''
      )
    },

    imageTitle () {
      let img = this['previewImage' + this.whichImageShowing]
      if (!img) {
        return false
      }
      return img && img.objectInfo ? img.objectInfo.objectName + ', ' + img.objectInfo.address + '<br>' + this.$i18n.t('alates') + ' ' +
        (img.objectInfo.dayPrice || (Math.ceil(img.objectInfo.price / 7))) + ('€ / ' + this.$i18n.t('öö').toLowerCase()) : ''
    },

    homepage () {
      return this.$route.name === 'homewlang' || this.$route.name === 'home'
    },

    previewImageStyle () {
      let style = {}
      if (!this.withSlider) {
        style.height = '100%'
        style.width = 'auto'
      }
      return style
    },

    viewerContainerStyle () {
      let style = {}
      style.height = ((this.contentAreaWidth - 14) / 16 * 9) + 'px' // 8px because of margin
      if (!this.withSlider) {
        style.height = ((this.contentAreaWidth - 8) / 16 * 8) + 'px'
      }
      return style
    },

  },

  methods: {
    ...methods,
    ...sharedMethods
  }
}
</script>

<style>

</style>
